/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import authRoles from '../../auth/authRoles';
import InstanceWrapper from '../../shared-components/layouts/InstanceWrapper';
import LessonView from './instance/LessonView';
import LessonForm from './instance/LessonForm';
import CommentForm from '../../shared-components/comments/CommentForm';
import InstanceComments from '../../shared-components/InstanceComments';
import ReplyForm from '../../shared-components/comments/ReplyForm';
import StatusDev from '../../shared-components/crud/instance/status/StatusDev';
import StatusProd from '../../shared-components/crud/instance/status/StatusProd';
import Version from '../../shared-components/crud/instance/version/Version';
import VersionView from '../../shared-components/crud/instance/version/VersionView';
import VersionForm from '../../shared-components/crud/instance/version/VersionForm';
import Export from '../../shared-components/crud/instance/export/Export';

const LessonConfig = {
  routes: [
    {
      path: 'lessons/:id',
      element: <InstanceWrapper />,
      children: [
        {
          path: '',
          element: <LessonView />,
          children: [
            {
              path: 'status/development',
              element: <StatusDev />
            },
            {
              path: 'status/production',
              element: <StatusProd />
            },
            {
              path: 'version',
              element: <Version />,
              auth: authRoles.leads,
              children: [
                {
                  path: '',
                  element: <VersionView />
                },
                {
                  path: ':versionId/edit',
                  element: <VersionForm />,
                  auth: authRoles.admin
                }
              ]
            },
            {
              path: 'export',
              element: <Export />,
              auth: authRoles.leads
            }
          ]
        },
        {
          path: 'edit',
          element: <LessonForm />,
          auth: authRoles.leadEditor
        },
        {
          path: 'comments',
          element: <InstanceComments category="lessons" collection='comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm collection='comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm collection='comments' />
            }
          ]
        },
        {
          path: 'imi-comments',
          element: <InstanceComments category="lessons" isIMI collection='imi_comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm isIMI collection='imi_comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm isIMI collection='imi_comments' />
            }
          ]
        },
        {
          path: 'pre-trial-comments',
          element: <InstanceComments category="lessons" collection='pre_trial_comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm isIMI collection='pre_trial_comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm isIMI collection='pre_trial_comments' />
            }
          ]
        }
      ]
    }
  ]
};

export default LessonConfig;
